







































































































































































































































































































































import Vue from 'vue'
import store from '../store'

export default Vue.component('scenario', {
  props: {
    step: Number,
    modal: Boolean
  },

  data () {
    return {
      // Scenarios
      scenarioName: null,
      farmName: null,
      paddockName: null,
      scenarioSaved: {
        status: false,
        timeout: 1500,
        message: "Scenario saved.",
        success: true
      },
      scenarioValue: null,
      scenarioModal: false,
      previousState: null
    }
  },

  mounted() {
    this.previousState = this.cleanSource(store.state)
    if (store.state.activeScenario) {
      let scenario = store.state.scenarios.filter((s:any) => s.value === store.state.activeScenario.value)[0]
      this.scenarioName = scenario.text
      this.farmName = scenario.farm
      this.paddockName = scenario.paddock
      this.scenarioValue = scenario
    }
  },

  computed: {
    selectedScenarioValue: {
      get: function(this: any) {
        let scenarios = this.getScenarios;
        if (scenarios.length > 0) {
          return scenarios[0];
        }
        return 0;
      },
      set: function(this: any, newValue: any) {
        this.scenarioName = newValue.text
        this.farmName = newValue.farm
        this.paddockName = newValue.paddock
        this.scenarioValue = newValue;
        store.dispatch("updateActiveScenario", newValue);
      }
    },

    getScenarios() {
      return store.getters.scenarios
    },
  },

  methods: {
  // Using native JSON functions removes reactivity
  // so we can clone an object without mutating the original source
  cleanSource: function(source: any) {
    return JSON.parse(JSON.stringify(source));
  },

  // Save new scenario
  saveScenario: function(this: any) {
    const newSaveObj:any = {
      text: this.scenarioName,
      date: new Date(),
      value: this.scenarioName,
      step1: this.cleanSource(store.state.step1),
      step2: this.cleanSource(store.state.step2),
      step3: this.cleanSource(store.state.step3),
      step5: this.cleanSource(store.state.step5),
      farm: this.farmName,
      paddock: this.paddockName
    };

    let nameIndex = store.state.scenarios.map((e: any) => {
      return e.text;
    }).indexOf(newSaveObj.text);
    let valueIndex = store.state.scenarios.map((e: any) => {
      return JSON.stringify(e.value);
    }).indexOf(JSON.stringify(newSaveObj.value));
    let farmIndex = store.state.scenarios.map((e: any) => {
      return e.farm;
    }).indexOf(newSaveObj.farm);
    let paddockIndex = store.state.scenarios.map((e: any) => {
      return e.paddock;
    }).indexOf(newSaveObj.paddock);
    /*let stepIndex = store.state.scenarios.map((e: any) => {
      return JSON.stringify(e[`step${this.step}`]);
    }).indexOf(JSON.stringify(newSaveObj[`step${this.step}`]));*/
    let stepIndex = this.previousState.scenarios.map((e: any) => {
      return JSON.stringify(e[`step${this.step}`]);
    }).indexOf(JSON.stringify(newSaveObj[`step${this.step}`]));
    this.previousState = this.cleanSource(store.state)

    // Return false if no name is provided
    if (!this.scenarioName) {
      this.scenarioSaved.message = "Please enter a scenario name.";
      this.scenarioSaved.success = false;
    // If data entry values, farm name or paddock name have been changed
    } else if (stepIndex < 0 || valueIndex < 0 || farmIndex < 0 || paddockIndex < 0) {
      // Create new scenario if it does not already exist
      if (nameIndex < 0) {
        store.state.scenarios.push(this.cleanSource(newSaveObj));
        this.selectedScenarioValue = newSaveObj;
        this.scenarioSaved.message = "Scenario " + this.scenarioName + " saved.";
      // Update existing scenario
      } else {
        store.state.scenarios[nameIndex] = newSaveObj;
        this.scenarioSaved.message = "Scenario " + this.scenarioName + " updated.";
      }
    // No changes made message
    } else {
      this.scenarioSaved.message = "A scenario with these values already exists.";
      this.scenarioSaved.success = false;
    }
    this.scenarioSaved.status = true;
    store.dispatch("updateScenarios", store.state.scenarios);

    setTimeout(() => {
      this.scenarioSaved.status = false;
      this.scenarioSaved.success = true;
      // this.scenarioModal = false;
    }, 3000);

    // console.log('Scenario saved: ', this.selectedScenarioValue)
  },

  // Select scenario and modify values accordingly
  selectScenario: function(this: any, event: any) {
    if (event !== undefined) {
      // Prefill the scenario name input with the relevant scenario
      let scenario = store.state.scenarios.filter((s:any) => s.value === event.value)[0]

      // Update scenario component values
      this.scenarioName = scenario.text;
      this.farmName = scenario.farm;
      this.paddockName = scenario.paddock;
      this.scenarioValue = scenario;
      store.dispatch("updateActiveScenario", scenario);

      // Update step values
      store.dispatch('updateStep1', this.cleanSource(scenario.step1));
      store.dispatch('updateStep2', this.cleanSource(scenario.step2));
      store.dispatch('updateStep3', this.cleanSource(scenario.step3));
      store.dispatch('updateStep5', this.cleanSource(scenario.step5));
    } else {
      this.clearScenario(true);
    }
    store.dispatch("updateScenarios", store.state.scenarios);

    // console.log('Scenario selected: ', scenario)
  },

  // Clear scenario
  clearScenario(this:any, clearName:boolean) {
    if (clearName) {
      this.scenarioName = null;
    }
    this.farmName = null;
    this.paddockName = null;
    this.$refs["loadScenario"].reset();
    store.dispatch("updateActiveScenario", null);
    // store.dispatch('resetState', false)
  },
  
  // Delete scenario
  deleteScenario: async function(this: any, name: string) {
    if (
      await this.$refs.confirm.open(
        "Delete Scenario",
        "Are you sure you want to delete this scenario: " + name,
        {
          color: "red",
          cta: "Delete"
        }
      )
    ) {
      let index = store.state.scenarios
        .map((e: any) => {
          return e.text;
        })
        .indexOf(name);
      if (index >= 0) {
        store.state.scenarios.splice(index, 1);
        this.clearScenario(true);
        store.dispatch("updateScenarios", store.state.scenarios);
      }
    }
    return 0;
  },
},

store
})
